import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import createWebSocketMiddleware from '@giantmachines/redux-websocket';
import combineReducers from '../reducers';
import { rootSaga } from './rootSaga'; // Переконайся, що створив rootSaga

const configureStore = (initialState) => {
  /* eslint-disable-next-line no-underscore-dangle */
  const devtools = window.__REDUX_DEVTOOLS_EXTENSION__;
  // Масив middleware
  const middlewares = [];

  // Якщо потрібен thunk
  middlewares.push(thunk);

  // Створення saga middleware і додавання його в масив
  const sagaMiddleware = createSagaMiddleware();
  middlewares.push(sagaMiddleware);

  // Створення websocket middleware з необхідними опціями
  const wsMiddleware = createWebSocketMiddleware({
    reconnectInterval: 3000,
    // Можна додати інші опції, наприклад, onOpen, onClose, onMessage тощо
  });
  middlewares.push(wsMiddleware);

  // Підключення Redux DevTools (якщо доступно)
  const enhancers = [];
  if (devtools) enhancers.push(devtools());

  // Створення store з використанням applyMiddleware та можливих enhancer'ів
  const store = createStore(
    combineReducers,
    initialState,
    compose(
      applyMiddleware(...middlewares),
      ...enhancers,
    ),
  );

  // Запуск rootSaga
  sagaMiddleware.run(rootSaga);

  // Підтримка hot-reloading для редюсерів
  if (module.hot) {
    module.hot.accept('../reducers/', () => {
      store.replaceReducer(combineReducers);
    });
  }

  return store;
};

export default configureStore;
